import { useFooterBanner } from '@occc-app/design-system';
import type { FooterBannerDetailItem } from '@occc-app/design-system';

// `isOnline` is requested in the fragment source (fragments.graphql). Keep this local type
// permissive (optional) so this stays resilient if `details` is missing for some systems.
type SiteSystemWithDetails = {
  details?: { isOnline?: boolean } | null;
};

export const STORE_OFFLINE_BANNER_HEADLINE =
  'This store has an offline terminal. Follow these steps to fix it:';

export const STORE_OFFLINE_TROUBLESHOOTING_STEPS: FooterBannerDetailItem[] = [
  {
    title: 'Verify network connectivity',
    description:
      'confirm the site has a stable internet connection and the POS can reach the host endpoint.',
  },
  {
    title: 'Attempt a test loyalty transaction',
    description:
      'run a test transaction on a product with an active loyalty offer, complete phone number entry on the pinpad, and verify whether a discount is applied.',
  },
  {
    title: 'Check host configuration',
    description:
      'confirm the host URL, port, site ID, and credentials match Open Commerce settings.',
  },
  {
    title: 'Reboot the terminal',
    description: 'perform a full controlled reboot coordinated with the site manager.',
  },
  {
    title: 'Contact support',
    description:
      'if the issue persists, open a ticket with the last connection timestamp, last transaction timestamp, error codes observed, and POS software version.',
  },
];

export const useStoreOfflineBanner = (
  siteSystemConfiguration: SiteSystemWithDetails[] | null | undefined,
) => {
  const isOffline = (siteSystemConfiguration ?? []).some(
    (system) => system.details?.isOnline === false,
  );

  useFooterBanner(isOffline ? STORE_OFFLINE_BANNER_HEADLINE : null, {
    severity: 'error',
    details: isOffline ? STORE_OFFLINE_TROUBLESHOOTING_STEPS : undefined,
  });
};
